import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Blog from './components/Blog';
import Footer from './components/Footer';
import LegalTexts from './components/LegalTexts';
import CookieBanner from './components/CookieBanner';
import { getConsentRecord, ConsentStatus } from './utils/consent';
import { initializeAnalyticsTracking, startAnalyticsPageTracking } from './utils/analytics';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [consentStatus, setConsentStatus] = useState<ConsentStatus | null>(
    getConsentRecord()?.status || null
  );

  useEffect(() => {
    initializeAnalyticsTracking();

    const handlePageView = () => startAnalyticsPageTracking();
    handlePageView();

    window.addEventListener('hashchange', handlePageView);
    return () => {
      window.removeEventListener('hashchange', handlePageView);
    };
  }, [consentStatus]);


  return (
    <div className="min-h-screen bg-gray-50">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <Hero />
      <About />
      <Projects />
      <Blog />
      <LegalTexts />
      <Footer />
      <CookieBanner onConsentChange={setConsentStatus} />
    </div>
  );
}

export default App;
